var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Menu",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Menu-2",
    "data-name": "Menu",
    d: "M8.626,20V17.142H23V20ZM0,11.428V8.572H23v2.857ZM0,2.858V0H23V2.858Z",
    transform: "translate(-0.001)",
    fill: "#3e87cb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon-menu.69cecb6245cfcc7da5061fc16d1cddb8.svg";
export { ForwardRef as ReactComponent };